import * as Types from '@crimeos-frontend/crime-os/graphql'

import { gql } from '@apollo/client'
import { Crime_Os_Common_FieldFragmentDoc } from './fields.generatedTypes'
export type Crime_Os_Common_GofFragment = {
  __typename: 'GoF'
  gofId: string
  name: string
  description?: string | null
  orderedFieldIds: Array<string>
  category: Types.GoFCategory
  fields: Array<
    | {
        __typename: 'CheckboxGroupField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        options: Array<string>
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        multiStringDefaultValue: Array<string>
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'DateField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        dateFieldDefaultValue?: string | null
        relativeDefaultValueConfig?: {
          __typename: 'DateRelativeDefaultValueConfig'
          operator: Types.ArithmeticOperation
          noOfDays: number
          DateValueEnum: Types.DateValueEnum
        } | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'DateTimeField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        dateTimeDefaultValue?: string | null
        relativeDefaultValueConfig?: {
          __typename: 'DateTimeRelativeDefaultValueConfig'
          dateConfig?: {
            __typename: 'DateRelativeDefaultValueConfig'
            operator: Types.ArithmeticOperation
            noOfDays: number
            DateValueEnum: Types.DateValueEnum
          } | null
          timeConfig?: {
            __typename: 'TimeRelativeDefaultValueConfig'
            operator: Types.ArithmeticOperation
            noOfSeconds: number
            TimeValueEnum: Types.TimeValueEnum
          } | null
        } | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'DropdownField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        options: Array<string>
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        stringDefaultValue?: string | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'EmailField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        regexErrorMessage?: string | null
        validationRegex?: string | null
        isUnique: boolean
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        stringDefaultValue?: string | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'FieldsSelectorField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        isDependent: boolean
        options: Array<string>
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        fieldSelectorFieldDefaultValue?: string | null
        dependentFields: Array<{
          __typename: 'DependentFields'
          option: string
          dependentFieldIds: Array<string>
        }>
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'FileUploaderField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        allowedFormats: Array<string>
        maxFileSizeKb: number
        maxFileCount: number
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        stringDefaultValues: Array<string>
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'FloatField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        isUnique: boolean
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        floatDefaultValue?: number | null
        rangeConfig?: {
          __typename: 'FloatRangeConfig'
          floatMinValue?: number | null
          floatMaxValue?: number | null
        } | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'IntegerField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        isUnique: boolean
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        intDefaultValue?: number | null
        rangeConfig?: {
          __typename: 'IntegerRangeConfig'
          intMinValue?: number | null
          intMaxValue?: number | null
        } | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'LongTextField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        stringDefaultValue?: string | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'LookupField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        isDependent: boolean
        systemFieldEnum?: Types.SystemFieldEnum | null
        lookupType: Types.LookupType
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'MultiSelectField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        options: Array<string>
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        multiStringDefaultValue: Array<string>
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'PhoneNumberField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        isUnique: boolean
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'PlainTextField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        regexErrorMessage?: string | null
        validationRegex?: string | null
        systemFieldEnum?: Types.SystemFieldEnum | null
        isUnique: boolean
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        stringDefaultValue?: string | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'RadioGroupField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        options: Array<string>
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        stringDefaultValue?: string | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'TimeField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        timeFieldDefaultValue?: string | null
        relativeDefaultValueConfig?: {
          __typename: 'TimeRelativeDefaultValueConfig'
          operator: Types.ArithmeticOperation
          noOfSeconds: number
          TimeValueEnum: Types.TimeValueEnum
        } | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
    | {
        __typename: 'URLField'
        fieldId: string
        constFieldId: string
        permissionType: Types.PermissionType
        gofId: string
        templateId: string
        name: string
        description?: string | null
        fieldType?: Types.FieldType | null
        isRequired: boolean
        helpText?: string | null
        tooltip?: string | null
        placeholderText?: string | null
        regexErrorMessage?: string | null
        validationRegex?: string | null
        isUnique: boolean
        systemFieldEnum?: Types.SystemFieldEnum | null
        displayConfig?: Types.FieldDisplayConfigEnum | null
        oneTimeEditable: boolean
        fieldsResetOnUpdate: Array<string>
        isAutomationIntegrated?: boolean | null
        stringDefaultValue?: string | null
        guidedActionConfig?: {
          __typename: 'GuidedActionConfig'
          displayName: string
          displayHeader: string
          contentType: Types.GuidedActionContentType
          content: string
          specialConfig: Array<{
            __typename: 'GuidedActionSpecialConfig'
            id: string
            value: string
            configType: Types.GuidedActionSpecialConfigType
          }>
        } | null
      }
  >
}

export type Crime_Os_Common_TemplateFragment = {
  __typename: 'Template'
  templateId: string
  description?: string | null
  iconUrl?: string | null
  name: string
  bulkImportTemplateUrl?: string | null
  orderedGofIds: Array<string>
  gofs: Array<{
    __typename: 'GoF'
    gofId: string
    name: string
    description?: string | null
    orderedFieldIds: Array<string>
    category: Types.GoFCategory
    fields: Array<
      | {
          __typename: 'CheckboxGroupField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          options: Array<string>
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          multiStringDefaultValue: Array<string>
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'DateField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          dateFieldDefaultValue?: string | null
          relativeDefaultValueConfig?: {
            __typename: 'DateRelativeDefaultValueConfig'
            operator: Types.ArithmeticOperation
            noOfDays: number
            DateValueEnum: Types.DateValueEnum
          } | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'DateTimeField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          dateTimeDefaultValue?: string | null
          relativeDefaultValueConfig?: {
            __typename: 'DateTimeRelativeDefaultValueConfig'
            dateConfig?: {
              __typename: 'DateRelativeDefaultValueConfig'
              operator: Types.ArithmeticOperation
              noOfDays: number
              DateValueEnum: Types.DateValueEnum
            } | null
            timeConfig?: {
              __typename: 'TimeRelativeDefaultValueConfig'
              operator: Types.ArithmeticOperation
              noOfSeconds: number
              TimeValueEnum: Types.TimeValueEnum
            } | null
          } | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'DropdownField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          options: Array<string>
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          stringDefaultValue?: string | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'EmailField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          regexErrorMessage?: string | null
          validationRegex?: string | null
          isUnique: boolean
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          stringDefaultValue?: string | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'FieldsSelectorField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          isDependent: boolean
          options: Array<string>
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          fieldSelectorFieldDefaultValue?: string | null
          dependentFields: Array<{
            __typename: 'DependentFields'
            option: string
            dependentFieldIds: Array<string>
          }>
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'FileUploaderField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          allowedFormats: Array<string>
          maxFileSizeKb: number
          maxFileCount: number
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          stringDefaultValues: Array<string>
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'FloatField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          isUnique: boolean
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          floatDefaultValue?: number | null
          rangeConfig?: {
            __typename: 'FloatRangeConfig'
            floatMinValue?: number | null
            floatMaxValue?: number | null
          } | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'IntegerField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          isUnique: boolean
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          intDefaultValue?: number | null
          rangeConfig?: {
            __typename: 'IntegerRangeConfig'
            intMinValue?: number | null
            intMaxValue?: number | null
          } | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'LongTextField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          stringDefaultValue?: string | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'LookupField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          isDependent: boolean
          systemFieldEnum?: Types.SystemFieldEnum | null
          lookupType: Types.LookupType
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'MultiSelectField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          options: Array<string>
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          multiStringDefaultValue: Array<string>
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'PhoneNumberField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          isUnique: boolean
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'PlainTextField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          regexErrorMessage?: string | null
          validationRegex?: string | null
          systemFieldEnum?: Types.SystemFieldEnum | null
          isUnique: boolean
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          stringDefaultValue?: string | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'RadioGroupField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          options: Array<string>
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          stringDefaultValue?: string | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'TimeField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          timeFieldDefaultValue?: string | null
          relativeDefaultValueConfig?: {
            __typename: 'TimeRelativeDefaultValueConfig'
            operator: Types.ArithmeticOperation
            noOfSeconds: number
            TimeValueEnum: Types.TimeValueEnum
          } | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
      | {
          __typename: 'URLField'
          fieldId: string
          constFieldId: string
          permissionType: Types.PermissionType
          gofId: string
          templateId: string
          name: string
          description?: string | null
          fieldType?: Types.FieldType | null
          isRequired: boolean
          helpText?: string | null
          tooltip?: string | null
          placeholderText?: string | null
          regexErrorMessage?: string | null
          validationRegex?: string | null
          isUnique: boolean
          systemFieldEnum?: Types.SystemFieldEnum | null
          displayConfig?: Types.FieldDisplayConfigEnum | null
          oneTimeEditable: boolean
          fieldsResetOnUpdate: Array<string>
          isAutomationIntegrated?: boolean | null
          stringDefaultValue?: string | null
          guidedActionConfig?: {
            __typename: 'GuidedActionConfig'
            displayName: string
            displayHeader: string
            contentType: Types.GuidedActionContentType
            content: string
            specialConfig: Array<{
              __typename: 'GuidedActionSpecialConfig'
              id: string
              value: string
              configType: Types.GuidedActionSpecialConfigType
            }>
          } | null
        }
    >
  }>
}

export const Crime_Os_Common_GofFragmentDoc = gql`
  fragment Crime_Os_Common_Gof on GoF {
    gofId
    name
    description
    orderedFieldIds
    category
    fields {
      ...Crime_Os_Common_Field
    }
  }
  ${Crime_Os_Common_FieldFragmentDoc}
`
export const Crime_Os_Common_TemplateFragmentDoc = gql`
  fragment Crime_Os_Common_Template on Template {
    templateId
    description
    iconUrl
    name
    bulkImportTemplateUrl
    gofs {
      ...Crime_Os_Common_Gof
    }
    orderedGofIds
  }
  ${Crime_Os_Common_GofFragmentDoc}
`
